// Shared text spacing helpers for Ge'ez keyboard/audio logic.
// ፡ is the Ge'ez word space and should behave like a normal space.
// ። is the Ge'ez full stop and should behave like a period.
// Period-like punctuation is treated as a 3-space audio pause.

export const SPACE_UNIT_SECONDS = 0.08;
export const PERIOD_PAUSE_UNITS = 3;

export function isSpaceLike(ch) {
  return ch === ' ' || ch === '፡';
}

export function isLineBreakLike(ch) {
  return ch === '\n' || ch === '\r' || ch === '\t';
}

export function isPeriodLike(ch) {
  return ch === '.' || ch === '።';
}

export function isAudioPause(ch) {
  return isSpaceLike(ch) || isLineBreakLike(ch) || isPeriodLike(ch);
}

export function getPauseUnits(ch) {
  if (isPeriodLike(ch)) return PERIOD_PAUSE_UNITS;
  if (isSpaceLike(ch) || isLineBreakLike(ch)) return 1;
  return 0;
}

export function getPauseDuration(ch) {
  return getPauseUnits(ch) * SPACE_UNIT_SECONDS;
}

export function countPauseUnits(str = '') {
  return [...str].reduce((total, ch) => total + getPauseUnits(ch), 0);
}

export function splitWords(text = '') {
  return text.split(/[\s፡።\.]+/).filter(Boolean);
}